import axios from 'axios';

// ----------------------------- o

const api = axios.create({
    baseURL: 'https://admin.voxpartnersclub.pl/', // prod
    // baseURL: 'https://voxuatapi.dev-is.pl/', // uat
    // baseURL: 'https://new-voxuatapi.dev-is.pl/', // new uat
    // baseURL: 'https://voxdevapi.dev-is.pl/', // dev
    // baseURL: 'https://new-voxdevapi.dev-is.pl/', // new dev
    headers: {
        'Authorization' : localStorage.getItem('access-token') ? localStorage.getItem('access-token') : '',
        'Access-Control-Allow-Credentials' : true,
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods' : 'GET, PUT, POST, DELETE, OPTIONS',
        'Access-Control-Allow-Headers' : 'application/json',
    }
})

// ----------------------------- o

export default api